module.exports = __webpack_public_path__ + "img/unique.7059bb4.webp";